import type { RenderItemProps } from '@/components/StructuredVirtualList'

import { EventInfoItem } from './components/EventInfoItem'

type Props = RenderItemProps<'eventInfos'>

export function Item(props: Props) {
  return props.type === 'item' ? <EventInfoItem {...props} /> : null
}
